import { render, staticRenderFns } from "./footer-translate.component.vue?vue&type=template&id=2ccac684&"
import script from "./footer-translate.component.vue?vue&type=script&lang=ts&"
export * from "./footer-translate.component.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports